import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { debounce } from 'vue-debounce';
import MandatoryColorModuleFilters from '@/modules/ColorModule/components/MandatoryColorModuleFilters.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorModuleSearch',
  props: {
    filtersActive: { type: Boolean },
    requestFiltersActive: { type: Boolean },
    activeTab: null,
    filters: null,
    searchQuery: null,
    showLatestColors: { type: Boolean, default: false }
  },
  emits: ['clearFilters', 'search', 'setFilters', 'toggleLatestColors', 'filterChange'],
  setup(__props: any, { emit }) {

const props = __props as { filtersActive: boolean, requestFiltersActive: boolean, activeTab: string, filters: any, searchQuery: string, showLatestColors: boolean };




const isCacheResetIconLoading = ref(false);

const filterActiveState = computed(() => {
    return props.activeTab === 'color-request' ? props.requestFiltersActive : props.filtersActive;
});

const onSearch = (query: string, shouldFetch: boolean = false) => {
    emit('search', { query, shouldFetch });
};

const debouncedColorSearch = debounce((event: any) => {
    onSearch(event.target.value, false);
}, 50);

const activateSpinningAnimation = () => {
    isCacheResetIconLoading.value = true;
    setTimeout(() => {
        isCacheResetIconLoading.value = false;
    }, 500);
};

const clearFilters = () => {
    emit('clearFilters');
    activateSpinningAnimation();
};

const onFilterActiveStateChange = (val: boolean) => {
    emit('setFilters', val);
};

const onLatestColorsToggle = (val: boolean) => {
    emit('toggleLatestColors', val);
};

return { __sfc: true,props, emit, isCacheResetIconLoading, filterActiveState, onSearch, debouncedColorSearch, activateSpinningAnimation, clearFilters, onFilterActiveStateChange, onLatestColorsToggle, MandatoryColorModuleFilters }
}

})